(function (){
    'use strict';

    angular
        .module('services')
        .service('AdmService', AdmService);

    AdmService.$inject = ['$http', 'API_BASE'];

    function AdmService($http, API_BASE) {
        var service                             = this;
        service.getDepartments                  = getDepartments;
        service.getDepartmentsForSelect         = getDepartmentsForSelect;
        service.save                            = save;
        service.deleteDepartment                = deleteDepartment;
        service.updateDepartment                = updateDepartment;
        service.getJobDescriptions              = getJobDescriptions;
        service.getResponsibilitiesForSelect    = getResponsibilitiesForSelect;
        service.getJobDescriptionsForSelect     = getJobDescriptionsForSelect;
        service.storeJobDescription             = storeJobDescription;
        service.deleteJobDescription            = deleteJobDescription;
        service.updateJobDescription            = updateJobDescription;
        service.getAdmUsersStaff                = getAdmUsersStaff;
        service.getProcesses                    = getProcesses;
        service.storeProcess                    = storeProcess;
        service.getProcessesForSelect           = getProcessesForSelect;
        service.deleteProcess                   = deleteProcess;
        service.updateProcess                   = updateProcess;
        service.getResponsible                  = getResponsible;
        service.getResponsiblePositions         = getResponsiblePositions;
        service.getSellers                      = getSellers;
        service.getAll                          = getAll;

        function getDepartments(query) {
            return $http.get(API_BASE + '/adm/department/list', {params:query});
        }

        function save(data) {
            return $http.post(API_BASE + '/adm/department/store', data);
        }

        function deleteDepartment(id)
        {
            return $http.delete(API_BASE + '/adm/department/delete/' + id);
        }

        function updateDepartment(data)
        {
            return $http.post(API_BASE + '/adm/department/update', data);
        }

        function getJobDescriptions(query)
        {
            return $http.get(API_BASE + '/adm/jobDescription/list', {params:query});
        }

        function getDepartmentsForSelect(query) {
            return $http.get(API_BASE + '/adm/department/list/select', {params:query});
        }

        function getResponsibilitiesForSelect(query) {
            return $http.get(API_BASE + '/adm/jobDescription/responsibility/getForSelect', {params:query});
        }

        function getJobDescriptionsForSelect(query)
        {
            return $http.get(API_BASE + '/adm/jobDescription/select', {params:query});
        }

        function storeJobDescription(data)
        {
            return $http.post(API_BASE + '/adm/jobDescription/store', data);
        }

        function deleteJobDescription(id)
        {
            return $http.delete(API_BASE + '/adm/jobDescription/delete/' + id);
        }

        function updateJobDescription(data)
        {
            return $http.post(API_BASE + '/adm/jobDescription/update', data);
        }

        function getAdmUsersStaff(query)
        {
            return $http.get(API_BASE + '/adm/jobDescription/staff', {params:query});
        }

        function getProcesses(query)
        {
            return $http.get(API_BASE + '/adm/process/list', {params:query});
        }

        function storeProcess(query)
        {
            return $http.post(API_BASE + '/adm/process/store', query);
        }

        function getProcessesForSelect(query)
        {
            return $http.get(API_BASE + '/adm/process/getForSelect', {params:query});
        }

        function deleteProcess(id)
        {
            return $http.delete(API_BASE + '/adm/process/delete/' + id);
        }

        function updateProcess(data)
        {
            return $http.post(API_BASE + '/adm/process/update', data);
        }

        function getResponsible(query)
        {
            return $http.get(API_BASE + '/adm/jobDescription/responsible', {params:query});
        }

        function getResponsiblePositions(query)
        {
            return $http.get(API_BASE + '/adm/jobDescription/responsible/positions', {params:query});
        }

        function getSellers(query)
        {
            return $http.get(API_BASE + '/adm/sellers', {params:query});
        }

        function getAll(query)
        {
            return $http.get(API_BASE + '/admusers/getall', {params:query});
        }        
    }
})();